import axios from 'axios';
import cache from 'axios-cache-plugin';
var hash = require('object-hash');

const apiBaseURL = process.env.NODE_ENV === 'production' ? '../api' : process.env.VUE_APP_API_URL;
let portal = 'default';
let uuid = '';
let API = cache(axios.create({
   baseURL: apiBaseURL,
   withCredentials: true
}), {
  maxCacheSize: 100
});
var pendingRequests = {};

// TODO - need to refine filters so we don't cache things like cart
//API.__addFilter(/.*/);
//API.__addFilter();

function post(module, path, data = {}, params = {}) {
  return _req('post', null, module, path, data, params);
}

function fetch(module, path, params = {}) {
  return _req('get', null, module, path, null, params);
}

function _req(method, packageName, module, path, data = null, params = {}) {
  params.portal = portal;

  if (uuid) {
    params.uuid = uuid;
  }

  if (module) {
    path = `${module}/${path}`;
  }

  if (packageName) {
    path = `${packageName}/${path}`;
  }

  let url = path;

  const currentReq = hash({ method, url, data, params });
  if (pendingRequests[currentReq]){
    return pendingRequests[currentReq];
  }
  pendingRequests[currentReq] = API({ method, url, data, params }).then(response => {
    if (response.headers['content-type'] !== 'application/json') {
      alert(`Fatal API Error\n${url}\nPlease see console`);
      console.error('API ERROR [', url, ']', params);
      console.error(response.data);
      return {};
    }

    return response.data.data;
  }).catch(err => {
    if (!err.response){
      throw "Server error with no description."
    }
    if (err.response.data)
      throw err.response.data;
    else
      throw err;
  }).finally(() => {
    delete pendingRequests[currentReq];
  });
  return pendingRequests[currentReq];
}

class PAP {
  constructor(type) {
    this.type = type;
  }

  get(id, date=null, cartItem = {}) {
    var params = { id, date, cartItem };

    return fetch(this.type, '', params);
  }

  category(id) {
    return fetch(this.type, 'category', { id });
  }

  categories(date) {
    return fetch(this.type, 'categories', { date });
  }

  list(category, date) {
    return fetch(this.type, 'list', { category, date });
  }
}

class Package extends PAP {
  constructor() {
    super("package");
  }

  get(id, packageItem = {}) {
    var params = { id, packageItem };

    return fetch(this.type, '', params);
  }
}

class P2P {
  get(state) {
    return fetch('p2p', '', state);
  }

  airlines() {
    return fetch('p2p', 'airlines');
  }
}


class Settings {
  all() {
    return fetch('settings', 'all');
  }

  general() {
    return fetch('settings', 'general');
  }

  client() {
    return fetch('settings', 'client');
  }
}

class Availability {
  month(month, category) {
    return fetch('availability', 'month', { month, category });
  }

  day(day, category, tempMonth) {
    return fetch('availability', 'day', { day, category, tempMonth });
  }
}

class Cart {
  load() {
    return fetch('cart', '');
  }

  loadBooking(bookingId, be) {
    return fetch('cart', 'load', { bookingId, be });
  }

  add(cartItem) {
    return post('cart', 'add', cartItem);
  }

  update(cartItem) {
    return post('cart', 'update', cartItem);
  }

  remove(cartItem) {
    return post('cart', 'remove', cartItem);
  }

  addGuest(guest) {
    return post('cart', 'addGuest', guest);
  }

  complete(payment) {
    return post('cart', 'complete', payment);
  }

  applyPromoCode(promoCode){
    return post('cart', 'applyPromoCode', promoCode);
  }

  applyGiftCert(giftCert){
    return post('cart', 'applyGiftCert', giftCert);
  }
}

class Agent {
  login(username, password) {
    return post('agent', 'login', { username, password });
  }

  addAffiliate(id) {
    return post('agent', 'addAffiliate', { id });
  }

  load() {
    return fetch('agent', 'load');
  }

  logout() {
    return post('agent', 'logout');
  }

  update(agent, newPassword1 = "", newPassword2 = "") {
    return post('agent', 'update', { agent, newPassword1, newPassword2 });
  }
}


export default {
  setPortal(p) {
    portal = p;
  },

  setUUID(u) {
    uuid = u;
  },

  cart: new Cart(),

  settings: new Settings(),

  availability: new Availability(),

  activity: new PAP('activity'),

  package: new Package(),

  product: new PAP('product'),

  p2p: new P2P(),

  agent: new Agent(),
};
